import React from "react";

export const QUESTIONS_TABLE = [
    {
        id: 1,
        title: (
            <>
                ¿Qué datos necesito
                <br /> para cotizar?
            </>
        ),
        content: (
            <>
                Necesitas saber{" "}
                <b>
                    los años de antigüedad, el
                    <span /> material de
                    <br /> construcción y el área en m2
                </b>{" "}
                de tu
                <span /> vivienda. Además, te
                <br /> recomendamos conocer el
                <span /> <b>valor aproximado de tu casa y/o cosas.</b>
            </>
        ),
    },
    {
        id: 2,
        title: (
            <>
                ¿Cuál es la cobertura
                <br /> principal?
            </>
        ),
        content: (
            <>
                Cubrimos daños ocasionados a tu casa y/o tus
                <span /> cosas por <br />
                <b>
                    incendio, explosión, humo, inundación
                    <span /> accidental o <br />
                    filtraciones y daños por vandalismo.
                </b>
            </>
        ),
    },
    {
        id: 3,
        title: (
            <>
                ¿Puedo elegir coberturas
                <br /> adicionales?
            </>
        ),
        content: (
            <>
                Puedes elegir coberturas como{" "}
                <b>
                    daños por
                    <span /> terremoto, robo,
                    <br /> daños a terceros y un completo
                    <span /> paquete de asistencias
                </b>
                , entre
                <br /> otros.{" "}
            </>
        ),
        hasLink: true,
    },
    {
        id: 4,
        title: (
            <>
                ¿Qué incluye el paquete de
                <br /> asistencias?
            </>
        ),
        content: (
            <>
                Incluye servicios de{" "}
                <b>
                    gasfitería, electricidad,
                    <span /> orientación
                    <br /> médica, ambulancia por accidente
                    <span />
                </b>{" "}
                para el asegurado,
                <br /> entre otros.
            </>
        ),
    },
    {
        id: 5,
        title: (
            <>
                ¿Qué otros beneficios
                <br /> adicionales me ofrece?
            </>
        ),
        content: (
            <>
                Si tu vivienda cuenta con medidas de seguridad <span /> como alarma,
                <br /> cámara, detector de humo y cerco <span /> eléctrico,{" "}
                <b>
                    contarás con un
                    <br /> 10% de descuento
                </b>
                *.
            </>
        ),
    },
];
